import React, { useEffect, useRef, useState } from 'react';
import { createRoot } from 'react-dom/client';
import { apiCall, removeParam, getBaseDir, userHasRole } from '../../../utils.js';
import ReportFilter from '../../../components/report/ReportFilter.js';
import TableBuilder from '../../../table_builder.js';
import FinancialMonthClosing from './FinancialMonthClosing';
import FinancialDRE from './FinancialDRE';
const XLSX = require('xlsx');


const tableRef = new TableBuilder({
  table: '#table-financial-reports-list',
  tableBody: '.js-financial-reports-table',
  data: [],
  rowsPerPage: 25,
  filter: false,
  maxPages: 0,
  tableRowRenderer: function(rowData) {
    return mountTableRow(rowData);
  },
});

// Detecta alteração de página na tabela
$(document).on('click', `.js-pagination-page-${tableRef.getTableId()}`, function(e) {
  e.preventDefault();
  let pageId = $(this).text();
  tableRef.setCurrentPage(pageId); //console.log('pageId', pageId);
});
// Detecta alteração de página na tabela
$(document).on('click', `.js-pagination-previous-page-${tableRef.getTableId()}`, function(e) {
  e.preventDefault();
  let pageId = tableRef.getCurrentPage() - 1; //console.log('previous pageId', pageId);
  if (pageId <= 0)
      return;
  tableRef.setCurrentPage(pageId); //console.log('pageId', pageId);
});
// Detecta alteração de página na tabela
$(document).on('click', `.js-pagination-next-page-${tableRef.getTableId()}`, function(e) {
  e.preventDefault();
  let pageId = tableRef.getCurrentPage() + 1; //console.log('next pageId', pageId);
  if (pageId > tableRef.getMaxPages())
      return;
  tableRef.setCurrentPage(pageId); //console.log('pageId', pageId);
});

const mountTableRow = (rowData) => {
  let url = getBaseDir() + 'pacientes/cadastros?' + $.param({
    patient_id: rowData.CLIENTE_ID,
    branch: rowData.FILIAL
  });

  return `<tr>
    <td>${rowData.FILIAL}</td>
    <td>${rowData.ID}</td>
    <td><a href="${url}" target="new">${rowData.NOME_COMPLETO}</a></td>
    <td>R$ ${rowData.TOTAL}</td>
    <td>${rowData.FORMA_PAGAMENTO}</td>
    <td>${rowData.TIPO_PACIENTE}</td>
  </tr>`;
}

function formatCurrency(value) {
  if (value === "" || value === null || value === undefined) return "";
  return Number(value).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
}

function RelatorioExtratoBancario({ data, contasBancarias, contaBancariaId }) {
  const { saldo_anterior, saldo_atual, entradas_por_dia, saidas_por_dia, saldos_por_dia, movimentacoes_por_dia } = data;
  const dias = Object.keys(saldos_por_dia).sort();

  return (
    <div>
      {dias.length == 0 ? `Não há movimentações para o período selecionado` : dias.map((dia, idx) => {
        console.log('dias map dia', dia);
        const movimentacoes = movimentacoes_por_dia[dia] || [];
        const entradas = entradas_por_dia[dia] || 0;
        const saidas = saidas_por_dia[dia] || 0;
        const saldo = saldos_por_dia[dia];
        const saldoAnterior = idx === 0 ? saldo_anterior : saldos_por_dia[dias[idx - 1]];
        const contaBancaria = contasBancarias.find(conta => conta.ID == contaBancariaId);

        // Separar entradas e saídas
        const movsEntrada = movimentacoes.filter(mov => Number(mov.VALUE) > 0);
        const movsSaida = movimentacoes.filter(mov => Number(mov.VALUE) < 0);

        // Montar linhas de movimentação
        const linhasMov = [
          // Entradas
          ...movsEntrada.map(mov => ({
            data: dia,
            doc: mov.ID_TRANSACAO?.slice(0, 8) || "",
            entrada: formatCurrency(mov.VALUE),
            saida: "",
            saldo_dia: "",
            descricao: mov.DESCRIPTION,
            conta: mov.CONTA_ID || "",
            conciliacoes: mov.CONCILIACOES || "",
          })),
          // Saídas
          ...movsSaida.map(mov => ({
            data: dia,
            doc: mov.ID_TRANSACAO?.slice(0, 8) || "",
            entrada: "",
            saida: formatCurrency(Math.abs(mov.VALUE)),
            saldo_dia: "",
            descricao: mov.DESCRIPTION,
            conta: mov.CONTA_ID || "",
            conciliacoes: mov.CONCILIACOES || "",
          })),
        ];

        return (
          <div key={dia} style={{ marginBottom: 60 }}>
            <h3 style={{ marginBottom: 0 }}>{dia}</h3>
            <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13, marginBottom: 10 }}>
              <thead>
                <tr>
                  <th style={{ border: '1px solid #ccc' }}>Data</th>
                  <th style={{ border: '1px solid #ccc' }}>Doc.</th>
                  <th style={{ border: '1px solid #ccc' }}>Entradas</th>
                  <th style={{ border: '1px solid #ccc' }}>Saídas</th>
                  <th style={{ border: '1px solid #ccc' }}>Saldo dia</th>
                  <th style={{ border: '1px solid #ccc' }}>Descrição</th>
                  <th style={{ border: '1px solid #ccc' }}>Conta</th>
                </tr>
              </thead>
              <tbody>
                {/* Saldo anterior */}
                <tr>
                  <td style={{ border: '1px solid #ccc' }}>{dia}</td>
                  <td style={{ border: '1px solid #ccc' }}></td>
                  <td style={{ border: '1px solid #ccc' }}></td>
                  <td style={{ border: '1px solid #ccc' }}></td>
                  <td style={{ border: '1px solid #ccc' }}>{formatCurrency(saldoAnterior)}</td>
                  <td style={{ border: '1px solid #ccc' }}>Saldo anterior</td>
                  <td style={{ border: '1px solid #ccc' }}></td>
                </tr>
                {/* Movimentações */}
                {linhasMov.map((linha, i) => {
                  let conciliacoes = JSON.parse(linha.conciliacoes);
                  let descricao =  conciliacoes.map((conc, idx) => (
                    <React.Fragment key={idx}>
                      {conc.CATEGORIA} {conciliacoes.length > 1 ? `- R$ ${formatCurrency(conc.VALOR)}` : ''}
                      {idx < conciliacoes.length - 1 && <br />}
                    </React.Fragment>
                  ));
                  return (
                    <tr key={i}>
                      <td style={{ border: '1px solid #ccc' }}>{new Date(linha.data).toLocaleDateString()}</td>
                      <td style={{ border: '1px solid #ccc' }}>{linha.doc}</td>
                      <td style={{ border: '1px solid #ccc', textAlign: 'right' }}>{linha.entrada}</td>
                      <td style={{ border: '1px solid #ccc', textAlign: 'right' }}>{linha.saida}</td>
                      <td style={{ border: '1px solid #ccc' }}>{linha.saldo_dia}</td>
                      <td style={{ border: '1px solid #ccc' }}>{descricao}</td>
                      <td style={{ border: '1px solid #ccc' }}>{contaBancaria.CONTA}</td>
                    </tr>
                  )
                })}
                {/* Totais do dia */}
                <tr>
                  <td style={{ border: '1px solid #ccc' }}></td>
                  <td style={{ border: '1px solid #ccc' }}></td>
                  <td style={{ border: '1px solid #ccc', textAlign: 'right', fontWeight: 'bold' }}>{formatCurrency(entradas)}</td>
                  <td style={{ border: '1px solid #ccc', textAlign: 'right', fontWeight: 'bold' }}>{formatCurrency(Math.abs(saidas))}</td>
                  <td style={{ border: '1px solid #ccc', fontWeight: 'bold' }}>{formatCurrency(saldo)}</td>
                  <td style={{ border: '1px solid #ccc' }} colSpan={2}></td>
                </tr>
              </tbody>
            </table>
          </div>
        );
      })}
    </div>
  );
}

const FinancialReports = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [branches, setBusinessBranches] = useState([]);

  const [selectedBranch, setSelectedBranch] = useState(null);
  const [hasAuthCode, setAuthCode] = useState(false);
  const [reportGenerated, setReportGenerated] = useState(false);

  const [formData, setFormData] = useState({
    branch: '',
    branchName: '',
    startDate: '',
    endDate: '',
    reportType: '',
    recordsPerPage: 25,
    page: 1,
    accountId: null
  })
  const interval = useRef(null);

  const [reportData, setReportData] = useState(null);

  const initData = () => {
    let userProfileResponse = { ...window._sessionData };
    setBusinessBranches(userProfileResponse.businessBranches);
    clearInterval(interval.current);
  }

  React.useEffect(() => {
    interval.current = setInterval(() => {
      if (window._sessionData.businessBranches && branches.length === 0) {
        initData();
      }
    }, 1000);

    tableRef.setFetchTableData(fetchTableData);
  }, []);

  React.useEffect(() => {
    if (formData.reportType == 'THEQUIRO_BANK_STATEMENT' && accounts.length === 0) {
      fetchAccoutns();
    }
  }, [formData.reportType]);

  const [accounts, setAccounts] = useState([]);

  const fetchAccoutns = () => {
    apiCall({
      endpoint: 'api/v1/financial/accounts?page=1',
      method: 'GET',
      successCallback: (response) => {
        console.log('response', response);
        setAccounts(response.results);
      } 
    });
  }

  const handleSubmit = (e) => {
    e.preventDefault();

    if (formData.reportType === '') {
      window.toast({
        error: true,
        text: "Selecione o tipo de relatório!"
      });
      return;
    }

    window.localStorage.setItem('FinancialReportsFormData', JSON.stringify(formData));
    fetchTableData()
  }

  const fetchTableData = (pageId = false) => {
    let formData = JSON.parse(window.localStorage.getItem('FinancialReportsFormData'));
    if (pageId) {
      formData.page = pageId;
      setFormData(formData);
      window.localStorage.setItem('FinancialReportsFormData', JSON.stringify(formData));
    }
    
    setReportGenerated(false);
    setIsLoading(true);

    apiCall({
      endpoint: 'api/v1/reports/financial',
      method: 'GET',
      data: {
        ...formData
      },
      successCallback: (response) => {
        console.log('response', response);

        setReportGenerated(true);
        setIsLoading(false);
        setReportData(response.data);

        if (response?.LABELS) {
          formData.startDate = response?.LABELS?.startDate;
          formData.endDate = response?.LABELS?.endDate;
        }
        setFormData(formData);
        window.localStorage.setItem('FinancialReportsFormData', JSON.stringify(formData));

        if (formData.reportType !== 'THEQUIRO_MONTH_CLOSING' && formData.reportType !== 'THEQUIRO_BANK_STATEMENT' && formData.reportType !== 'THEQUIRO_DRE') {
          setTimeout(() => { tableRef.renderPage(tableRef.getCurrentPage(), false, response.RESULTS, false, response.LABELS.total) }, 1000);
        }
      },
      errorCallback: (err) => {
        setIsLoading(false);
        console.error('error', err);
      }
    });
  }

  const exportToExcel = () => {
    let formData = JSON.parse(window.localStorage.getItem('FinancialReportsFormData'));
    formData.export = true;
    apiCall({
      endpoint: 'api/v1/reports/financial',
      method: 'GET',
      data: {
        ...formData
      },
      successCallback: (response) => {
        console.log('response', response);

        if (response?.RESULTS) {
          const worksheet = XLSX.utils.json_to_sheet(response.RESULTS);
          const workbook = XLSX.utils.book_new();
          XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
          XLSX.writeFile(workbook, 'relatorio_contratos_'+window.getSaoPauloDateTime()+'.xlsx');
        }

        /*if (formData.reportType === 'THEQUIRO_MONTH_CLOSING' && response?.data) {
          let start = new Date(response.data.period.start_date);
          let end = new Date(response.data.period.end_date);
          let daysDiff = Math.ceil((end.getTime() - start.getTime()) / (1000 * 60 * 60 * 24));
          console.log('daysDiff', daysDiff);
          if (daysDiff > 28) {
            // Montar Receitas
            const receitas = [];
            let receitasItens = [];
            response.data.revenue.items.forEach((cat) => {
              cat.ITENS.forEach((item) => {
                receitasItens.push({
                  data: item.DATA_PAGAMENTO,
                  documento: item.ID,
                  descricao: item.DESCRICAO,
                  valor_bruto: Number(item.VALOR_CONCILIADO),
                  valor_taxa: item.VALOR_TAXA ? Number(item.VALOR_TAXA) : 0,
                  valor_liquido: item.VALOR_CONCILIADO != item.VALOR_TAXA ? Number(item.VALOR_CONCILIADO) - (item.VALOR_TAXA ? Number(item.VALOR_TAXA) : 0) : item.VALOR_CONCILIADO,
                  conciliado_por: item.CONCILIADO_POR,
                  data_reconciliacao: item.DATA_RECONCILIACAO,
                  categoria: 'RECEITA CLIENTE'
                });
              });
            });
            receitasItens = receitasItens.sort((a, b) => new Date(a.data) - new Date(b.data));
            receitasItens.forEach((item) => {
              receitas.push({
                'Data': item.data,
                'Documento': item.documento,
                'Descrição': item.descricao,
                'Valor Bruto': item.valor_bruto,
                'Valor Taxa': item.valor_taxa,
                'Valor Líquido': item.valor_liquido,
                //'Conciliado por': item.conciliado_por,
                //'Data Reconciliacao': item.data_reconciliacao ? new Date(item.data_reconciliacao).toLocaleDateString('pt-BR') : '',
                'Categoria': item.categoria
              });
            });

            // Montar Despesas
            const despesas = [];
            let despesasItens = [];
            response.data.expenses.items.forEach((cat) => {
              cat.ITENS.forEach((item) => {
                despesasItens.push({
                  data: item.DATA_PAGAMENTO,
                  documento: item.ID,
                  descricao: item.DESCRICAO,
                  valor: Math.abs(Number(item.VALOR)),
                  conciliado_por: item.CONCILIADO_POR,
                  data_reconciliacao: item.DATA_RECONCILIACAO,
                  categoria: cat.CATEGORIA
                });
              });
            });
            despesasItens = despesasItens.sort((a, b) => new Date(a.data) - new Date(b.data));
            despesasItens.forEach((item) => {
              despesas.push({
                'Data': item.data,
                'Documento': item.documento,
                'Descrição': item.descricao,
                'Valor': item.valor,
                //'Conciliado por': item.conciliado_por,
                //'Data Reconciliacao': item.data_reconciliacao ? new Date(item.data_reconciliacao).toLocaleDateString('pt-BR') : '',
                'Categoria': item.categoria
              });
            });

            // Criar workbook com duas abas
            const wb = XLSX.utils.book_new();
            const wsReceitas = XLSX.utils.json_to_sheet(receitas);
            const wsDespesas = XLSX.utils.json_to_sheet(despesas);
            XLSX.utils.book_append_sheet(wb, wsReceitas, 'Receitas');
            XLSX.utils.book_append_sheet(wb, wsDespesas, 'Despesas');
            XLSX.writeFile(wb, 'fechamento_mensal_'+window.getSaoPauloDateTime()+'.xlsx');
          } else if (daysDiff == 0) {
            // Extrato Diário
            const extrato = [];
            let movimentos = [];
            // Receitas
            response.data.revenue.items.forEach((cat) => {
              cat.ITENS.forEach((item) => {
                movimentos.push({
                  data: item.DATA_PAGAMENTO,
                  documento: item.ID,
                  entrada: Number(item.VALOR_CONCILIADO),
                  saida: 0,
                  descricao: item.DESCRICAO,
                  conta: cat.CATEGORIA || 'RECEITA CLIENTE'
                });
              });
            });
            // Despesas
            response.data.expenses.items.forEach((cat) => {
              cat.ITENS.forEach((item) => {
                movimentos.push({
                  data: item.DATA_PAGAMENTO,
                  documento: item.ID,
                  entrada: 0,
                  saida: Math.abs(Number(item.VALOR)),
                  descricao: item.DESCRICAO,
                  categoria: cat.CATEGORIA
                });
              });
            });
            movimentos = movimentos.sort((a, b) => new Date(a.data) - new Date(b.data));
            let saldo = 0;
            movimentos.forEach((item) => {
              saldo += item.entrada - item.saida;
              extrato.push({
                'Data': item.data ? item.data : '',
                'Documento': item.documento,
                'Entradas': item.entrada > 0 ? item.entrada : '',
                'Saídas': item.saida > 0 ? item.saida : '',
                'Saldo do dia': saldo,
                'Descrição': item.descricao,
                'Categoria': item.categoria
              });
            });
            // Exportar para Excel
            const wb = XLSX.utils.book_new();
            const wsExtrato = XLSX.utils.json_to_sheet(extrato);
            XLSX.utils.book_append_sheet(wb, wsExtrato, 'Extrato Diário');
            XLSX.writeFile(wb, 'extrato_diario_'+window.getSaoPauloDateTime()+'.xlsx');
            return;
          }
        }*/
       // ... existing code ...
        if (formData.reportType === 'THEQUIRO_MONTH_CLOSING' && response?.data) {
          const { revenue, expenses } = response.data;
          
          // Cabeçalho da planilha
          const sheetData = [
            ['Data', 'Doc.', 'Entradas', 'Saídas', 'Saldo dia', 'Descrição', 'Categoria']
          ];

          // Combinar receitas e despesas em um único array
          let movimentos = [];
          
          // Adicionar receitas
          revenue.items.forEach(cat => {
            cat.ITENS.forEach(item => {
              movimentos.push({
                data: item.DATA_PAGAMENTO,
                documento: '',
                valor: Number(item.VALOR_CONCILIADO),
                descricao: item.DESCRICAO,
                categoria: 'RECEITA CLIENTE',
                isEntrada: true,
                filial: item.FILIAL
              });
            });
          });

          // Adicionar despesas
          expenses.items.forEach(cat => {
            cat.ITENS.forEach(item => {
              movimentos.push({
                data: item.DATA_PAGAMENTO,
                documento: '',
                valor: Math.abs(Number(item.VALOR)),
                filial: item.FILIAL,
                categoria: cat.CATEGORIA,
                isEntrada: false,
                descricao: item.DESCRICAO
              });
            });
          });

          // Ordenar por data
          movimentos.sort((a, b) => new Date(a.data) - new Date(b.data));

          // Agrupar por dia
          const movimentosPorDia = {};
          movimentos.forEach(mov => {
            if (!movimentosPorDia[mov.data]) {
              movimentosPorDia[mov.data] = [];
            }
            movimentosPorDia[mov.data].push(mov);
          });

          // Calcular saldos
          let saldoAtual = 0;
          const dias = Object.keys(movimentosPorDia).sort();

          dias.forEach((dia, idx) => {
            const movimentosDoDia = movimentosPorDia[dia];
            const saldoAnterior = idx === 0 ? 0 : saldoAtual;

            // Adicionar saldo anterior
            sheetData.push([
              dia,
              '',
              '',
              '',
              Number(saldoAnterior),
              'Saldo anterior',
              ''
            ]);

            // Adicionar movimentações do dia
            let entradasDia = 0;
            let saidasDia = 0;

            movimentosDoDia.forEach(mov => {
              const entrada = mov.isEntrada ? mov.valor : '';
              const saida = !mov.isEntrada ? mov.valor : '';
              
              if (mov.isEntrada) entradasDia += mov.valor;
              else saidasDia += mov.valor;

              sheetData.push([
                dia,
                mov.documento,
                entrada ? Number(entrada) : '',
                saida ? Number(saida) : '',
                '',
                mov.descricao,
                mov.categoria,
                mov.filial
              ]);
            });

            // Atualizar saldo
            saldoAtual += entradasDia - saidasDia;

            // Adicionar totais do dia
            sheetData.push([
              '',
              '',
              Number(entradasDia),
              Number(saidasDia),
              Number(saldoAtual),
              '',
              ''
            ]);
          });

          // Criar a planilha e fazer o download
          const ws = XLSX.utils.aoa_to_sheet(sheetData);
          const wb = XLSX.utils.book_new();
          XLSX.utils.book_append_sheet(wb, ws, 'Fechamento Mensal');
          XLSX.writeFile(wb, 'fechamento_mensal_'+window.getSaoPauloDateTime()+'.xlsx');
        }

        if (formData.reportType === 'THEQUIRO_BANK_STATEMENT' && response?.data) {
          const { saldo_anterior, entradas_por_dia, saidas_por_dia, saldos_por_dia, movimentacoes_por_dia } = response.data;
          const dias = Object.keys(saldos_por_dia).sort();
        
          // Cabeçalho da planilha
          const sheetData = [
            ['Data', 'Doc.', 'Entradas', 'Saídas', 'Saldo dia', 'Descrição', 'Conta']
          ];
        
          dias.forEach((dia, idx) => {
            const movimentacoes = movimentacoes_por_dia[dia] || [];
            const entradas = entradas_por_dia[dia] || 0;
            const saidas = saidas_por_dia[dia] || 0;
            const saldo = saldos_por_dia[dia];
            const saldoAnterior = idx === 0 ? saldo_anterior : saldos_por_dia[dias[idx - 1]];
        
            // Saldo anterior
            sheetData.push([
              dia,
              '',
              '',
              '',
              saldoAnterior,
              'Saldo anterior',
              ''
            ]);
        
            // Entradas e saídas
            movimentacoes.forEach(mov => {
              const isEntrada = Number(mov.VALUE) > 0;
              const doc = mov.ID_TRANSACAO?.slice(0, 8) || '';
              const entrada = isEntrada ? mov.VALUE : '';
              const saida = !isEntrada ? Math.abs(mov.VALUE) : '';
              let descricao = 'RECEITA CLIENTE';
              let conta = mov.CONTA_ID || '';
        
              // Se tiver conciliações e for saída, monta a descrição igual ao render
              if (!isEntrada && mov.CONCILIACOES) {
                try {
                  const conciliacoes = JSON.parse(mov.CONCILIACOES);
                  descricao = conciliacoes.map(conc =>
                    conciliacoes.length > 1
                      ? `${conc.CATEGORIA} - R$ ${Number(conc.VALOR).toLocaleString('pt-BR', { minimumFractionDigits: 2 })}`
                      : conc.CATEGORIA
                  ).join(`${String.fromCharCode(10)}`);
                } catch (e) {
                  // fallback
                }
              }
        
              sheetData.push([
                dia,
                doc,
                entrada ? Number(entrada).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }) : '',
                saida ? Number(saida).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }) : '',
                '',
                descricao,
                conta
              ]);
            });
        
            // Totais do dia
            sheetData.push([
              '',
              '',
              Number(entradas).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
              Number(Math.abs(saidas)).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
              Number(saldo).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
              '',
              ''
            ]);
          });
        
          // Cria a planilha e faz o download
          const ws = XLSX.utils.aoa_to_sheet(sheetData);
          const wb = XLSX.utils.book_new();
          XLSX.utils.book_append_sheet(wb, ws, 'Extrato Bancário');
          XLSX.writeFile(wb, 'extrato_bancario_'+window.getSaoPauloDateTime()+'.xlsx');
        }

        window.toast({
            error: false,
            text: "Exportação realizada com sucesso."
        })
      },
      errorCallback: (err) => {
        console.error('error', err);
      }
    });
  }

  return (
    <>
     <div className="col-12 p-2">
      <div className="d-flex justify-content-center">
        <form className="row w-50" onSubmit={(e) => handleSubmit(e)}>
          <ReportFilter setFormData={setFormData} setAsOpen={true} />
          <div className="form-group mb-3">
            <label>Relatório:</label>
            <select className="form-control form-control" onChange={(e) => {
              setFormData((prev) => {
                return {
                  ...prev,
                  reportType: e.target.value
                }
              });
              setReportGenerated(false);
            }}>
              <option selected default value="">-- Selecione --</option>
              {/*<option value="AVALIATION_EXAM">Quem agendou avaliação</option>*/}
              <option value="THEQUIRO_CONTRACTS_LAUNCHED">Contratos Lançados no TheQuiro</option>
              <option value="THEQUIRO_ATTENDED_PNS_LAUNCHED">PNs Atendidos Lançados no TheQuiro</option>
              {userHasRole('ADMIN') && <option value="THEQUIRO_MONTH_CLOSING">Fechamento do mês no TheQuiro</option>}
              {userHasRole('ADMIN') && <option value="THEQUIRO_BANK_STATEMENT">Extrato Bancário</option>}
              {userHasRole('ADMIN') && <option value="THEQUIRO_DRE">DRE</option>}
              {/*<option value="PERCENTAGE_ACTIVE_TREATMENT_PLAN_">Quantos % terminou tratamento inicial</option>*/}
            </select>
          </div>
          {formData.reportType == 'THEQUIRO_BANK_STATEMENT' && (
            <div className="form-group mb-3">
              <label>Conta Corrente:</label>
              <select className="form-control form-control" onChange={(e) => {
                setFormData((prev) => {
                  return {
                    ...prev,
                    accountId: e.target.value
                  }
                });
              }}>
                <option value="" selected disabled>-- Selecione --</option>
                {accounts.map((account) => (
                  <option value={account.ID}>{account.CONTA}</option>
                ))}
              </select>
            </div>
          )}
          <div className="form-group mb-3">
            <button type='submit' className="btn btn-primary">Gerar Relatório</button>
            {formData.reportType && reportGenerated && (
              <button type="button" className='btn btn-secondary ml-2' onClick={() => exportToExcel()}>Exportar para Excel</button>
            )}
          </div>
        </form>
      </div>
      {isLoading && 'Carregando, por favor, aguarde...'}
      {formData.reportType != 'THEQUIRO_MONTH_CLOSING' && formData.reportType != 'THEQUIRO_BANK_STATEMENT' && formData.reportType != 'THEQUIRO_DRE' && reportGenerated && (
        <>
          Relatório de pacientes {formData.reportType && `(${type[formData.reportType]})`}<br />Período: {formData.startDate} {formData.endDate !== '' && `até ${formData.endDate}`}
          <table className="table table-striped table-bordered" id="table-financial-reports-list">
            <thead>
              <tr>
                <th>Filial</th>
                <th>{formData.reportType === 'THEQUIRO_CONTRACTS_LAUNCHED' ? 'Contrato' : 'Conta Corrente'}</th>
                <th>Paciente</th>
                <th>{formData.reportType === 'THEQUIRO_CONTRACTS_LAUNCHED' ? 'Contrato' : 'Total'}</th>
                <th>Forma Pgto.</th>
                <th>Tipo Paciente</th>
              </tr>
            </thead>
            <tbody className="js-financial-reports-table"></tbody>
          </table>
        </>
      )}

      {formData.reportType == 'THEQUIRO_MONTH_CLOSING' && reportGenerated && reportData && (
        <FinancialMonthClosing data={reportData} />
      )}

      {formData.reportType == 'THEQUIRO_DRE' && reportGenerated && reportData && (
        <FinancialDRE data={reportData} branches={branches} />
      )}

      {
        formData.reportType == 'THEQUIRO_BANK_STATEMENT' && reportGenerated && reportData && (
          <div>
            <h3>Relatório de Movimentações de Conciliação Bancária</h3>
            <div>
              <RelatorioExtratoBancario data={reportData} contasBancarias={accounts} contaBancariaId={formData.accountId} />
            </div>
          </div>
        )
      }
      </div>
    </>
  );
}

try {
  if (document.getElementById('js-financial-reports-content')) {
    const container = document.getElementById('js-financial-reports-content');
    const root = createRoot(container); // createRoot(container!) if you use TypeScript
    root.render(<FinancialReports />);
  }
} catch(err) {
  console.error('FinancialReports error', err);
}

const type = {
    THEQUIRO_CONTRACTS_LAUNCHED: "Contrados Lançados no TheQuiro",
    THEQUIRO_ATTENDED_PNS_LAUNCHED: "PNs Atendidos Lançados no TheQuiro"
}